import React from "react";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaEnvelope,
  FaWhatsapp,
  FaInstagram,
  FaMapMarkerAlt,
  FaClock,
} from "react-icons/fa";

const SmallNavbar = () => (
  <div className="bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 text-white py-3">
    <div className="container mx-auto flex flex-col lg:flex-row justify-between items-center px-6">
      {/* Left side - Contact Info */}
      <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6 text-sm">
        <div className="flex items-center space-x-2 hover:text-blue-200 transition-colors">
          <FaEnvelope className="text-blue-300" />
          <a href="mailto:info@rakan-eg.com" className="font-medium">
            info@rakan-co.com
          </a>
        </div>
        <div className="flex items-center space-x-2 text-blue-200">
          <FaMapMarkerAlt className="text-blue-300" />
          <span>Egypt - Engineering Excellence</span>
        </div>
        <div className="flex items-center space-x-2 text-blue-200">
          <FaClock className="text-blue-300" />
          <span>24/7 Emergency Support</span>
        </div>
      </div>

      {/* Right side - Social Media & CTA */}
      <div className="flex items-center space-x-4 mt-3 lg:mt-0">
        <span className="text-sm text-blue-200 hidden md:block">Follow Us:</span>
        <div className="flex space-x-3">
          <a
            href="https://wa.me/+201126090982"
            target="_blank"
            rel="noopener noreferrer"
            className="group"
            title="WhatsApp"
          >
            <FaWhatsapp
              size={24}
              className="text-white bg-green-500 rounded-full p-1 shadow-lg hover:bg-green-600 hover:scale-110 transition-all duration-300"
            />
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61579625686434"
            target="_blank"
            rel="noopener noreferrer"
            className="group"
            title="Facebook"
          >
            <FaFacebookF
              size={24}
              className="text-white bg-blue-600 rounded-full p-1 shadow-lg hover:bg-blue-700 hover:scale-110 transition-all duration-300"
            />
          </a>
          <a
            href="https://www.linkedin.com/company/rakan-co/"
            target="_blank"
            rel="noopener noreferrer"
            className="group"
            title="LinkedIn"
          >
            <FaLinkedinIn
              size={24}
              className="text-white bg-blue-500 rounded-full p-1 shadow-lg hover:bg-blue-600 hover:scale-110 transition-all duration-300"
            />
          </a>
          <a
            href="https://www.instagram.com/rakaan_eg/"
            target="_blank"
            rel="noopener noreferrer"
            className="group"
            title="Instagram"
          >
            <FaInstagram
              size={24}
              className="text-white bg-gradient-to-br from-purple-500 to-pink-500 rounded-full p-1 shadow-lg hover:from-purple-600 hover:to-pink-600 hover:scale-110 transition-all duration-300"
            />
          </a>
        </div>
        <a 
          href="/contact-us"
          className="hidden lg:block bg-yellow-500 hover:bg-yellow-400 text-blue-900 px-4 py-1 rounded-full text-sm font-semibold transition-all duration-300 hover:scale-105 shadow-lg"
        >
          Get Quote
        </a>
      </div>
    </div>
  </div>
);

export default SmallNavbar;
